import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import { ErrorPanel } from '../../../components/display/ErrorPanel';

// Components Styled
import { Container } from './style';

/**
 * 404 de dentro de la aplicación: lo pinta el `path="*"` del bloque de
 * `MainLayout`, así que llega CON la cabecera, el menú y el nombre del usuario
 * arriba. Es la diferencia que importa — una dirección equivocada no debe
 * parecerse a que te han echado de la sesión.
 *
 * Sin sesión no se llega hasta aquí: `MainLayout` redirige al login antes de
 * pintar nada. Y si lo que falla es un loader, manda el `errorElement` de la
 * raíz (`pages/utils/Error`), que es la versión suelta de esta misma tarjeta.
 */
export default function NotFoundPage(): JSX.Element {
  const { t } = useTranslation(['errors', 'buttons']);
  const navigate = useNavigate();

  return (
    <Container>
      <ErrorPanel
        title={t('errors:pageNotFound')}
        actionLabel={t('buttons:back')}
        // Aquí NO hace falta recarga dura: no ha reventado nada, la aplicación
        // está entera y el operario tiene el menú a mano. Una navegación normal
        // le deja en su pantalla de inicio sin volver a arrancar la app.
        onAction={() => navigate('/')}
      />
    </Container>
  );
}
